import { useQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { activityApi, type RecapRange } from '../api/campaignsApi';
import { activityKeys } from '../queryKeys';

/**
 * Ads activity feed — pulls all entries with module=ads for the current
 * location.
 */
export function useAdsActivity() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  return useQuery({
    queryKey: activityKeys.ads(locationId),
    queryFn: () => activityApi.list({ module: 'ads', locationId, limit: 100 }),
    enabled: !!locationId,
    staleTime: 60_000,
  });
}

export function useAdsRecap(range: RecapRange = 'last7') {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  return useQuery({
    queryKey: activityKeys.recap(locationId, range),
    queryFn: () => activityApi.recap(locationId, range),
    enabled: !!locationId,
    staleTime: 5 * 60_000,
  });
}
